/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/sort-styles */
import { colors } from "colors"
import { Dimensions, Platform, StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  animatedViewContainer: {
    borderBottomEndRadius: 20,
    borderBottomLeftRadius: 20,
    overflow: "hidden",
  },
  bottomBlock: { height: 20 },
  container: { height: "100%", padding: 10 },
  contentContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 20,
    widhth: "100%",
  },
  contentDateText: {
    color: colors.placeholder,
    fontFamily: typography.primary.normal,
    fontSize: 13,
    marginTop: 5,
  },
  flatListContainer: {
    padding: 10,
  },
  emptyContainer: {
    alignItems: "center",
    flex: 1,
    height: "100%",
    justifyContent: "center",
  },
  emptyTitleText: { fontFamily: typography.primary.normal, fontSize: 25, padding: 20 },
  flex: { flex: 1 },
  greenText: { color: colors.green },
  headerBottomBigContainer: {
    width: "100%",
    paddingBottom: 10,
    paddingHorizontal: 15,
    marginBottom: 10,
    height: "auto",
  },
  headerBottomPointContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: 10,
  },
  headerBottomButton: {
    display: "flex",
    flexDirection: "row",
    minWidth: 60,
    borderWidth: 2,
    borderRadius: 20,
    height: 35,
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    backgroundColor: "white",
    paddingHorizontal: 10,
  },
  headerBottomButtonImage: {
    width: 20,
    height: 20,
    resizeMode: "contain",
    marginRight: 5,
  },
  headerBottomPointText: {
    fontFamily: typography.primary.normal,
    fontSize: 26,
    fontWeight: "900",
    letterSpacing: 1.5,
  },
  headerBottomTitleText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    fontSize: 18,
    marginTop: -20,
  },
  headerContainer: {
    alignItems: "center",
    height: 40,
  },
  paginationDotContainer: {
    alignSelf: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  headerContentContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 15,
    width: "100%",
  },
  headerIconContainer: { alignSelf: "flex-start", display: "flex", flexDirection: "row" },
  headerTopPointText: { color: colors.white, fontFamily: typography.primary.normal, fontSize: 17 },
  linearGradient: {
    borderBottomEndRadius: 20,
    borderBottomLeftRadius: 20,
    overflow: "hidden",
    paddingTop: 10,
    position: "absolute",
  },
  pointContentText: { fontFamily: typography.primary.normal },
  pointContentTitle: { fontFamily: typography.primary.normal, fontSize: 20, marginTop: 20 },
  redText: { color: colors.error },
  separator: { backgroundColor: colors.placeholder, height: 0.5 },
  pointContainer: {
    backgroundColor: colors.pivilegePointContainer,
    borderRadius: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 10,
    paddingHorizontal: 10,
  },
  text: { color: colors.white, fontFamily: typography.primary.normal },
  mt10: { paddingTop: 10, paddingBottom: 20 },
  mt15: { marginTop: 15 },
  showAllText: {
    fontFamily: typography.primary.normal,
    fontSize: 14,
  },
  voucherContainer: {
    // marginRight: 20,
    // borderWidth: 1,
    // borderRadius: 10,
    // padding: 5,
    // overflow: "hidden",
    // shadowColor: "#000", // Optional shadow for depth
    // shadowOffset: { width: 0, height: 4 },
    // shadowOpacity: 0.3,
    // shadowRadius: 6,
    // minWidth: 200,
    // maxWidth: 400,
    justifyContent: "center",
    minWidth: "49%",
    paddingVertical: 10,
    marginRight: 15,
    borderRadius: 10,
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOpacity: 0.3,
    shadowRadius: 6,
    elevation: 8,
    overflow: "hidden",
  },
  voucherImage: {
    alignSelf: "center",
    borderRadius: 10,
  },
  unactiveFilter: {
    borderWidth: 2,
    borderRadius: 8,
    marginRight: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  unactiveFilterText: {
    marginHorizontal: 20,
  },
  activeFilter: {
    borderWidth: 2,
    borderRadius: 8,
    marginRight: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  activeFilterText: {
    marginHorizontal: 20,
    color: colors.white,
  },
  desc_text: {
    color: colors.black,
    fontFamily: typography.thin.normal,
    fontSize: 10,
  },

  stampContainer: {
    borderRadius: 10,
    overflow: Platform.OS === "android" ? "hidden" : "visible", // 'hidden' clips shadow on iOS
    backgroundColor: "#fff", // Required for elevation to work correctly
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 5, // Effective range: 1–24 for Android
    width: "100%",
    marginBottom: 15,
    marginTop: 10,
  },

  stampTextContainer: {
    padding: 5,
    backgroundColor: "white",
  },
  voucherImage: {
    alignSelf: "center",
    borderRadius: 10,
  },
  stampImage: {
    alignSelf: "center",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  stampProgressContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
    paddingHorizontal: 5,
    width: "100%",
    backgroundColor: "white",
  },
  stampSegment: {
    width: 20,
    height: 6,
    backgroundColor: "#E0E0E0",
    borderRadius: 2,
  },
  stampCountText: {
    fontSize: 12,
    color: colors.lightGrey,
  },
  contentContainerV: {
    justifyContent: "center",
    width: 180,
    maxWidth: 180,
    marginRight: 15,
    borderRadius: 10,
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOpacity: 0.3,
    shadowOffset: { width: 0, height: 0.5 },
    shadowRadius: 4,
    elevation: 2,
  },

  voucherText: {
    flex: 1,
    width: "100%",
    fontFamily: typography.primary.normal,
    fontSize: 16,
    marginTop: 10,
    textAlign: "left",
    paddingLeft: 10,
  },
  pointText: {
    fontFamily: typography.primary.normal,
    fontSize: 14,
    marginTop: 5,
    width: "100%",
    textAlign: "left",
    marginLeft: 10,
  },
})
